import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { ViewerUrlProvider } from './ViewerUrlProvider';
import { MixPanelEventEmitter as MixpanelService } from '../metrics/MixPanelEventEmitter';
import { ILinkInfo, ShareLinkButton } from './ShareLinkButton';

export const ViewShareLinkButton: React.FC<{
    trackingFrom: 'Community' | 'Sharing Set Up';
    shareBody?: string;
    hasDuration?: boolean;
    duration?: number;
    asLink?: boolean;
    buttonLabel?: string;
    buttonLabelWhenNativeShare?: string;
}> = ({
    trackingFrom,
    shareBody,
    hasDuration = true,
    duration,
    asLink,
    buttonLabel = 'Share Link',
    buttonLabelWhenNativeShare = 'Share Link'
}) => {

    const careMapState = useInstance(CareMapState);
    const trackingService = useInstance(MixpanelService);
    const viewerUrlProvider = useInstance(ViewerUrlProvider);

    const shareDescription = shareBody || `I’d like to share ${careMapState.getPatientFirstName()}'s innerhive with you. Open the view-only link to get started!`;

    const getDurationMessage = (linkDurationDays: number) => (
        hasDuration && <>This link allows anyone to <strong>view</strong> your innerhive for <strong>{linkDurationDays} day{linkDurationDays > 1 ? 's' : ''}</strong>, without an account. Or, they can create an account for ongoing access to non-private care info.</>
    );

    const createLinkUrl = async ({ linkDurationDays }: ILinkInfo) => {
        const result = await careMapState.createViewerAccessToken(duration || linkDurationDays!);
        return viewerUrlProvider.buildViewerUrl({ access_token: result.session_token });
    };

    const onSharingOpened = ({ linkDurationDays }: ILinkInfo) => {
        trackingService.track('View-Only Mobile Sharing Opened', () => ({
            duration: linkDurationDays,
            from: trackingFrom
        }));
    };

    const onLinkCopied = ({ linkDurationDays }: ILinkInfo) => {
        trackingService.track('View-Only Share Link Copied', () => ({ duration: linkDurationDays }));
    };

    return (
        <ShareLinkButton
            asLink={asLink}
            data-type="view-link"
            buttonLabel={buttonLabel}
            buttonLabelWhenNativeShare={buttonLabelWhenNativeShare}

            // TODO: this was Share Care Map
            // but accidentally
            shareSubject=""

            shareBody={shareDescription}
            createLinkUrl={createLinkUrl}
            onLinkCopied={onLinkCopied}
            onMobileSharingOpened={onSharingOpened}
            hasDuration={hasDuration}
            getDurationMessage={getDurationMessage}
        />
    );
};
